import React from "react";
import cx from "classnames";
import { Button } from "components/Button";
import { ReactComponent as TrashIcon } from "sections/Betting/Betslip/assets/trash.svg";
import * as styles from "./PickSlip.module.scss";

type TrashIconButtonType = {
  onClick: () => void;
};

const TrashIconButton = ({ onClick }: TrashIconButtonType) => {
  return (
    <Button
      variant={`blurred`}
      className={cx(styles.iconButton, styles.trash)}
      onClick={onClick}
    >
      <TrashIcon />
    </Button>
  );
};

export default TrashIconButton;
